import { render, staticRenderFns } from "./GalleryPresentation.vue?vue&type=template&id=f0fd8b8e&"
import script from "./GalleryPresentation.vue?vue&type=script&lang=js&"
export * from "./GalleryPresentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports